<template>
  <a-form-item
    :label="label"
    class="input-limit clearfix"
  >
    <div
      v-decorator="[fieldkey, {
        validateTrigger: ['change', 'blur'],
        rules: [{
          required: required, message: $t('message[751]')
        },{
          validator: checkValue
        }],
        initialValue: input
      }]"
    >
      <a-input
        v-model="input"
        :placeholder="placeholder"
        class="fl"
        @input="handleInput"
      />
      <span class="text-num fl">{{ count }} / {{ max }}</span>
    </div>
  </a-form-item>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    fieldkey: {
      type: String,
      default: 'name'
    },
    value: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: 20
    },
    placeholder: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      input: ''
    }
  },
  computed: {
    count () {
      let len = parseInt(this.$getZhStrlen(this.input))
      return len > this.max ? this.max : len
    }
  },
  watch: {
    value (val) {
      this.input = val
    }
  },
  mounted () {
    this.input = this.value
  },
  methods: {
    handleInput (e) {
      let val = e.target.value

      /* if (val.length >= this.max) {
        val.slice(0, this.max)
      } */
      val = this.$subZhStr(val, this.max, false)

      this.input = val

      this.$emit('change', val)
    },
    checkValue (rule, value = '', callback) {
      if (this.$getZhStrlen(value) <= this.max) {
        callback()
      } else {
        callback(new Error('输入字数不能超过' + this.max))
      }
    }
  }
}
</script>

<style scoped lang="scss">
.ant-input {
  width: 303px;
  border-radius: 4px 0 0 4px;
}
.text-num {
  display: inline-block;
  width: 72px;
  height: 32px;
  color: #666;
  text-align: center;
  border-radius: 0 4px 4px 0;
  border: solid 1px #D8D8D8;
  border-left: 0;
}
</style>
